import { castRouteIds } from 'plugins/router/routes/castRouteIds'
import type { RouteRecordRaw } from 'vue-router'

export const dialogFilePreview: RouteRecordRaw = {
	component: () => import('@/components/modules/Documents/DialogPreview.vue'),
	name: 'dialogFilePreview',
	path: '/preview/:id',
	meta: {
		offline: false,
	},
	props: castRouteIds,
}
